<template>
    <div id="controls-container">
        <div id="controls-selector-container">
            <div class="buttons-container noselect">
                <div class="button-holder" :class="{'tab-active': this.play_mode == 'manual'}" v-on:click="changePlayMode('manual')">
                    <a>Manual</a>
                </div>
                <div class="button-holder" :class="{'tab-active': this.play_mode == 'auto'}" v-on:click="changePlayMode('auto')">
                    <a>Auto</a>
                </div>
            </div>
            <div class="controls-widget-container">
                <div id="controls-inner-container" v-if="this.play_mode === 'manual'">

                    <div :class="{'control-inputs-container': this.state.is_small}">
                        <div class="input-control" :class="{'controls-row': !this.state.is_small}">
                            <div class="bet-container">
                                <div class="bet-input-group">
                                    <span class="manual-bet-label">
                                        <span>{{$trans('label.Bet')}}</span>
                                        <span v-if="!state.is_small">({{$trans('label.Max Bet')}} : {{utils.comma(this.state.max_bet)}} {{this.state.currency}})</span>
                                    </span>
                                    <input type="number" name="bet-size" :min="this.state.min_bet" :max="this.state.max_bet" :step="this.state.min_bet" v-model="bet_size"/>
                                    <span class="currency text-uppercase">{{this.state.currency}}</span>
                                </div>
                                <div class="moneyinput-container">
                                    <span>
                                        <button class="inputmoney-button" v-for="bet_amount in this.state.bet_amount_range" @click="addBetSize(bet_amount)" @mousedown="setBetSizeTimer(bet_amount)" @mouseup="clearBetSizeTimer">+{{utils.comma(bet_amount)}}</button>
                                        <button class="inputmoney-button" @click="addBetSize(0)">{{$trans('form.Reset')}}</button>
                                    </span>
                                </div>
                                <!--
                                <div class="strategy-container">
                                    <span class="strategy-invalid-data">test</span>
                                </div>
                                -->
                            </div>
                        </div>
                        <div class="input-control" :class="{'controls-row': !this.state.is_small}">
                            <div class="autocash-container">
                                <div class="bet-input-group">
                                    <span>{{$trans('label.Auto Cash Out')}}</span>
                                    <input type="number" name="cash-out" min="1" max="100000" step="0.01" v-model="auto_cash_out"/>
                                    <span>x</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="button-container">
                        <div class="bet-button-container">
                            <span v-if="utils.inArray(['IN_PROGRESS'], this.state.game_state) && this.state.play_state === 'idle'">
                                <button :class="this.button_class" @click="placeBet">
                                    <span class="button-label place-bet">{{$trans('label.Next Game Bet')}}</span>
                                </button>
                            </span>

                            <span v-if="utils.inArray(['STARTING', 'ENDED'], this.state.game_state) && this.state.play_state === 'idle'">
                                <button :class="this.button_class" @click="placeBet">
                                    <span class="button-label place-bet">{{$trans('label.Place bet')}}</span>
                                </button>
                            </span>

                            <span v-if="utils.inArray(['IN_PROGRESS', 'ENDED'], this.state.game_state) && this.state.play_state === 'queue'">
                                <button :class="this.button_class" @click="cancelBet">
                                    <span class="button-label cancel-bet">{{$trans('label.Cancel bet')}}</span>
                                </button>
                            </span>

                            <span v-if="utils.inArray(['STARTING'], this.state.game_state) && this.state.play_state === 'betting'">
                                <button :class="this.button_class">
                                    <span>{{$trans('label.Betting')}}</span>
                                </button>
                            </span>

                            <span v-if="utils.inArray(['IN_PROGRESS'], this.state.game_state) && this.state.play_state === 'playing'">
                                <button :class="this.button_class" @click="cashOut">
                                    <span class="button-label bet-running-amount">
                                        <span>{{$trans('label.Cash Out')}}</span><br>
                                        <span class="possible-profit">@ {{utils.comma((this.bet_amount * this.state.game_at).toFixed(2))}} {{this.state.currency}}</span>
                                    </span>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div id="strategy-container" v-if="this.play_mode === 'auto'">
                    <div class="widget-container">
                        <div class="auto-bet-container">
                            <div class="stra-base-bet">
                                <span class="bet-title">{{$trans('label.Base Bet')}}: </span>
                                <input type="number" :min="this.state.min_bet" :max="this.state.max_bet" :step="this.state.min_bet" :value="this.auto.base_bet" @input="updateBetAmount" :disabled="this.auto.active" />
                                <span>{{this.state.currency}}</span>
                            </div>
                            <div class="stra-cash-out-at">
                                <span class="bet-title">{{$trans('label.Auto Cash Out at')}}:</span>
                                <input type="number" min="1" max="100000" step="0.01" :value="this.auto.auto_cash_at" @input="updateAutoCashAt" :disabled="this.auto.active" decimal-places />
                                <span>x</span>
                            </div>
                            <!--
                            <div class="stra-max-bet-stop">
                                <span class="bet-title">다음 베팅 금액이</span>
                                <input type="number" :value="this.auto.max_bet_stop" :min="this.state.min_bet" @input="updateMaxBetStop" :disabled="this.auto.active" />
                                <span>{{this.state.currency}}</span>
                                <span class="bet-title">이상이면 정지</span>
                            </div>
                            -->
                            <div class="stra-max-bet-stop">
                                <span class="bet-title">{{$trans('label.Stop if bet is', {currency: this.state.currency})}}:</span>
                                <div>
                                    <input type="number" :value="this.auto.max_bet_stop" :min="this.state.min_bet" @input="updateMaxBetStop" :disabled="this.auto.active" />
                                    <span>{{this.state.currency}}</span>
                                </div>
                            </div>
                            <div class="stra-on-loss">
                                <span class="bet-title">{{$trans('label.On loss')}}: </span>
                                <div>
                                    <input type="radio" class="stra-on-loss-return-to-base-radio" value="return_to_base" name="onLoss" @change="updateOnLoss" :disabled="this.auto.active" :checked="this.auto.on_loss_selected_opt == 'return_to_base'" />
                                    <span>{{$trans('label.Return to base bet')}}</span>
                                    <br>
                                    <input type="radio" class="stra-on-loss-increase-bet-by" value="increase_bet_by" name="onLoss" @change="updateOnLoss" :disabled="this.auto.active" :checked="this.auto.on_loss_selected_opt == 'increase_bet_by'" />
                                    <span class="strategy-text">{{$trans('label.Increase bet by')}}:</span>
                                    <input type="number" :value="this.auto.on_loss_increase_qty" :min="this.state.min_bet" :max="this.state.max_bet" :step="this.state.min_bet" @input="updateOnLossQty" :disabled="this.auto.active" />
                                    <span>{{this.state.currency}}</span>
                                </div>
                            </div>
                            <div class="stra-on-win">
                                <span class="bet-title">{{$trans('label.On win')}}: </span>
                                <div>
                                    <input type="radio" class="stra-on-win-return-to-base-radio" value="return_to_base" name="onWin" @change="updateOnWin" :disabled="this.auto.active" :checked="this.auto.on_win_selected_opt == 'return_to_base'" />
                                    <span>{{$trans('label.Return to base bet')}}</span>
                                    <br>
                                    <input type="radio" class="stra-on-win-increase_bet_by" value="increase_bet_by" name="onWin" @change="updateOnWin" :disabled="this.auto.active" :checked="this.auto.on_win_selected_opt == 'increase_bet_by'" />
                                    <span class="strategy-text">{{$trans('label.Increase bet by')}}:</span>
                                    <input type="number" :value="this.auto.on_win_increase_qty" :min="this.state.min_bet" :max="this.state.max_bet" :step="this.state.min_bet" @input="updateOnWinQty" :disabled="this.auto.active">
                                    <span>{{this.state.currency}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="control-buttons">
                        <span class="strategy-invalid-data">{{this.auto.invalid_text}}</span>
                        <span class="strategy-invalid-data">{{this.auto.invalid_text2}}</span>
                        <div class="buttons-container">
                            <button class="strategy-start" @click="autoBetRun" :disabled="this.auto.active || this.auto.invalid_data || !this.state.user_id">RUN!</button>
                            <button class="strategy-stop" @click="autoBetStop" :disabled="!this.auto.active">STOP</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "controls-container",
        props: ['state'],
        data: function()
        {
            let play_mode = 'manual';
            let bet_size = 0;
            let auto_cash_out = 2.00;
            let base_bet = this.state.min_bet;
            let auto_cash_at = 2;
            let on_loss_selected_opt = 'return_to_base';
            let on_loss_increase_qty = this.state.min_bet * 2;
            let on_win_selected_opt = 'return_to_base';
            let on_win_increase_qty = this.state.min_bet * 2;
            let max_bet_stop = this.state.min_bet * 100;

            try {
                play_mode = localStorage['play_mode'] ? localStorage['play_mode'] : 'manual';
                bet_size = localStorage['bet_size'] == '' || localStorage['bet_size'] == undefined ? 0 : Number(localStorage['bet_size']);
                auto_cash_out = localStorage['auto_cash_out'] ? Number(localStorage['auto_cash_out']) : 2.00;
                base_bet = localStorage['base_bet'] ? Number(localStorage['base_bet']) : this.state.min_bet;
                auto_cash_at = localStorage['auto_cash_at'] ? localStorage['auto_cash_at'] : 2;
                on_loss_selected_opt = localStorage['on_loss_selected_opt'] ? localStorage['on_loss_selected_opt'] : 'return_to_base';
                on_loss_increase_qty = localStorage['on_loss_increase_qty'] ? Number(localStorage['on_loss_increase_qty']) : this.state.min_bet * 2;
                on_win_selected_opt = localStorage['on_win_selected_opt'] ? localStorage['on_win_selected_opt'] : 'return_to_base';
                on_win_increase_qty = localStorage['on_win_increase_qty'] ? Number(localStorage['on_win_increase_qty']) : this.state.min_bet * 2;
                max_bet_stop = localStorage['max_bet_stop'] ? Number(localStorage['max_bet_stop']) : this.state.min_bet * 100;
            } catch (e) {}

            return {
                utils: utils,

                initial_disable: true,
                button_class: null,

                // play_mode: localStorage['play_mode'] ? localStorage['play_mode'] : 'manual', // manual, auto
                play_mode: play_mode, // manual, auto

                // bet_size: localStorage['bet_size'] == '' || localStorage['bet_size'] == undefined ? 0 : Number(localStorage['bet_size']),
                bet_size: bet_size,
                bet_size_timer: null,
                // auto_cash_out: localStorage['auto_cash_out'] ? Number(localStorage['auto_cash_out']) : 2.00,
                auto_cash_out: auto_cash_out,
                bet_amount: 0,

                auto: {
                    active: false,
                    // base_bet: localStorage['base_bet'] ? Number(localStorage['base_bet']) : this.state.min_bet,
                    base_bet: base_bet,
                    last_bet_amount: null,
                    // auto_cash_at: localStorage['auto_cash_at'] ? localStorage['auto_cash_at'] : 2,
                    auto_cash_at: auto_cash_at,

                    // Options: return_to_base, increase_bet_by
                    // on_loss_selected_opt: localStorage['on_loss_selected_opt'] ? localStorage['on_loss_selected_opt'] : 'return_to_base',
                    // on_loss_increase_qty: localStorage['on_loss_increase_qty'] ? Number(localStorage['on_loss_increase_qty']) : this.state.min_bet * 2,
                    on_loss_selected_opt: on_loss_selected_opt,
                    on_loss_increase_qty: on_loss_increase_qty,

                    // Options: return_to_base, increase_bet_by
                    // on_win_selected_opt: localStorage['on_win_selected_opt'] ? localStorage['on_win_selected_opt'] : 'return_to_base',
                    // on_win_increase_qty: localStorage['on_win_increase_qty'] ? Number(localStorage['on_win_increase_qty']) : this.state.min_bet * 2,
                    on_win_selected_opt: on_win_selected_opt,
                    on_win_increase_qty: on_win_increase_qty,

                    invalid_data: false,
                    invalid_text: null,
                    invalid_text2: null,

                    // max_bet_stop: localStorage['max_bet_stop'] ? Number(localStorage['max_bet_stop']) : this.state.min_bet * 100,
                    max_bet_stop: max_bet_stop,
                },
            };
        },
        created()
        {
            if (this.auto.active) {
                this.autoBetRun();
            }
            EventBus.$on('reconnect_bet', this.onReconnectBet);
        },
        mounted()
        {
            EventBus.$emit('push_component', 'controls-container');

            this.initialDisableTimeout();
        },
        beforeUpdate()
        {
            // console.log('controls-container before update');
            this.setBetSize(this.bet_size);

            // localStorage['bet_size'] = this.bet_size;
            // localStorage['auto_cash_out'] = this.auto_cash_out;
            this.bet_size = this.bet_size;
            this.auto_cash_out = this.auto_cash_out;

            if (this.play_mode == 'auto') {
                this.auto.invalid_data = this.validation();
                this.auto.invalid_text = this.auto.invalid_data ? this.auto.invalid_data : null;
            }
        },
        updated()
        {
            // console.log('controls-container update');
        },
        beforeDestroy()
        {
            EventBus.$off('reconnect_bet', this.onReconnectBet);
        },
        methods: {
            onReconnectBet(data)
            {
                this.bet_amount = data.bet;
            },
            initialDisableTimeout()
            {
                let self = this;
                if (this.initial_disable) {
                    this.button_class = 'bet-button disable unselect';
                }
                setTimeout(function() {
                    self.initial_disable = false;
                    self.button_class = 'bet-button';
                }, AppConstants.BetButton.INITIAL_DISABLE_TIME);
            },
            changePlayMode(mode)
            {
                if (this.play_mode == 'manual' && mode == 'auto' && this.state.play_state !== 'idle') {
                    // return alert('이번게임이 끝날때까지 기다려주세요.');
                    return alert(this.$trans('alert.Please wait until the current game had finished'));
                }
                if (this.play_mode == 'auto' && mode == 'manual' && this.auto.active) {
                    // return alert('자동 케시아웃을 중단해주세요. 오른쪽 정지버튼을 클릭해주세요.');
                    return alert(this.$trans('alert.Please stop the auto cash out first_Click the stop button on the bottom right'));
                }
                this.play_mode = mode;
                try {
                    localStorage['play_mode'] = mode;
                } catch (e) {}
            },
            addBetSize(amount)
            {
                let bet_size = Number(this.bet_size);
                if (amount > 0) {
                    bet_size += amount;
                } else {
                    bet_size = 0;
                }
                this.setBetSize(bet_size);
            },
            setBetSize(bet_size)
            {
                if (this.state.balance <= bet_size) {
                    bet_size = Number(this.state.balance) - (Number(this.state.balance) % this.state.bet_amount_range[0]);
                    this.clearBetSizeTimer();
                }
                this.bet_size = Number(utils.uncomma(bet_size));
            },
            setBetSizeTimer(amount)
            {
                let self = this;
                this.clearBetSizeTimer();
                self.bet_size_timer = setInterval(function() {
                    self.setBetSize(Number(self.bet_size) + Number(amount));
                    self.clearBetSizeTimer();
                    self.bet_size_timer = setInterval(function() {
                        self.setBetSize(Number(self.bet_size) + Number(amount));
                    }, 70);
                }, 400);
            },
            clearBetSizeTimer()
            {
                clearInterval(this.bet_size_timer);
            },
            placeBet() {
                if (this.state.play_state == 'idle' && !this.initial_disable) {
                    let bet_amount = this.bet_size;
                    let auto_cash_out = StateLib.parseCashOut(this.auto_cash_out);
                    this.bet(bet_amount, auto_cash_out);
                }
            },
            placeAutoBet()
            {
                let base_bet = this.auto.base_bet;
                let current_bet = base_bet;
                let last_game_play = this.lastGamePlay();

                if (last_game_play == 'LOST') {
                    if (this.auto.on_loss_selected_opt == 'return_to_base') {
                        current_bet = base_bet;
                    } else { // increase_bet_by
                        console.assert(Clib.isNumber(Number(this.auto.on_loss_increase_qty)));
                        if (this.auto.last_bet_amount) {
                            current_bet = this.auto.last_bet_amount;
                        }
                        current_bet = current_bet + Number(this.auto.on_loss_increase_qty);
                    }
                } else if (last_game_play == 'WON') {
                    if (this.auto.on_win_selected_opt == 'return_to_base') {
                        current_bet = base_bet;
                    } else { // increase_bet_by
                        console.assert(Clib.isNumber(Number(this.auto.on_win_increase_qty)));
                        if (this.auto.last_bet_amount) {
                            current_bet = this.auto.last_bet_amount;
                        }
                        current_bet = current_bet + Number(this.auto.on_win_increase_qty);
                    }
                }

                let fixed_current_bet = Number(current_bet);

                this.auto.last_bet_amount = fixed_current_bet;

                if (fixed_current_bet > 0 && fixed_current_bet <= this.state.balance && fixed_current_bet <= this.state.max_bet && fixed_current_bet <= this.auto.max_bet_stop) {
                    this.bet(fixed_current_bet, Math.round(this.auto.auto_cash_at * 100), false);
                } else {

                    let message = null;
                    let invalid_data = Clib.parseBet(this.$trans, fixed_current_bet, this.state.currency, this.state.min_bet, this.state.max_bet);
                    if (invalid_data instanceof Error) {
                        message = invalid_data.message ? invalid_data.message : null;
                    }

                    if (!(fixed_current_bet <= this.state.balance)) {
                        message = this.$trans('alert.Not enough balance');
                    }

                    this.autoBetStop();

                    if (message) {
                        alert(message);
                    }
                }
            },
            /**
             * Places a bet with a giving amount.
             *
             * @param bet_amount
             * @param cash_out
             * @param callback
             */
            bet(bet_amount, auto_cash_out, callback)
            {
                console.assert(typeof bet_amount == 'number');
                console.assert(Clib.isInteger(bet_amount));
                console.assert(!auto_cash_out || (typeof auto_cash_out === 'number' && auto_cash_out >= 100));

                if (!Clib.isInteger(bet_amount) || bet_amount < this.state.min_bet) {
                    // return alert(`베팅 금액은 ${utils.comma(this.state.min_bet)}${this.state.currency} 이상이어야 합니다.`);
                    return alert(this.$trans('alert.The bet amount should be greater than', {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency}));
                }
                if (bet_amount > this.state.max_bet) {
                    // return alert(`베팅 금액은 ${utils.comma(this.state.min_bet)}${this.state.currency}원 이하 여야합니다.`);
                    return alert(this.$trans(`alert.The bet must be less no more than`, {max_bet: utils.comma(this.state.max_bet), currency: this.state.currency}));
                }
                if (bet_amount % this.state.min_bet > 0) {
                    // alert(`배팅금액은 ${utils.comma(this.state.min_bet)} 단위어야 합니다.`);
                    return alert(this.$trans('alert.Expecting bet to be divisible by', {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency}));
                }

                this.bet_amount = bet_amount;

                this.state.play_state = 'queue';
                this.state.next_bet_amount = bet_amount;
                this.state.next_auto_cash_out = auto_cash_out;
                this.state.placing_bet = true;

                if (this.state.game_state === 'STARTING') {
                    return this.state.socket.doBet(this.state, bet_amount, auto_cash_out, callback);
                }

                if (callback) {
                    callback(null, 'WILL_JOIN_NEXT');
                }
            },
            cancelBet()
            {
                if (!this.state.next_bet_amount) {
                    return console.error('Can not cancel next bet, wasn\'t going to make it...');
                }
                this.state.play_state = 'idle';
                this.state.next_bet_amount = null;
                this.state.placing_bet = false;
            },
            cashOut()
            {
                let self = this;
                self.state.cashing_out = true;
                this.state.socket.ws.emit('cash_out', self.state.game_id, function(error) {
                    if (error) {
                        self.state.cashing_out = false;
                        console.warn('Cashing out error: ', error);
                        alert(`Cash out fail [${error}]`);
                        EventBus.$emit('cashing_out_error'); // TODO: This is not listened anywhere, check if a component needs to listen to it.
                    }
                });
                this.initialDisableTimeout();
            },
            lastGamePlay()
            {
                if (this.lastGamePlayed()) {
                    if (this.state.game_history[0].player_info[this.state.user_id].stopped_at) {
                        return 'WON';
                    } else {
                        return 'LOST';
                    }
                }
                return 'NOT_PLAYED';
            },
            lastGamePlayed()
            {
                return !!this.state.game_history[0].player_info[this.state.user_id];
            },
            autoBetRun()
            {
                this.auto.active = true;
                try {
                    localStorage['active'] = this.auto.active;
                } catch (e) {}
                EventBus.$on('game_starting', this.placeAutoBet);
            },
            autoBetStop()
            {
                this.auto.active = false;
                try {
                    localStorage['active'] = this.auto.active;
                } catch (e) {}
                EventBus.$off('game_starting', this.placeAutoBet);
            },
            updateOnLoss(e)
            {
                this.auto.on_loss_selected_opt = e.target.value;
                try {
                    localStorage['on_loss_selected_opt'] = this.auto.on_loss_selected_opt;
                } catch (e) {}
            },
            updateOnWin(e)
            {
                this.auto.on_win_selected_opt = e.target.value;
                try {
                    localStorage['on_win_selected_opt'] = this.auto.on_win_selected_opt;
                } catch (e) {}
            },
            updateBetAmount(e)
            {
                this.auto.base_bet = e.target.value;
                try {
                    localStorage['base_bet'] = this.auto.base_bet;
                } catch (e) {}
            },
            updateAutoCashAt(e)
            {
                this.auto.auto_cash_at = e.target.value;
                try {
                    localStorage['auto_cash_at'] = this.auto.auto_cash_at;
                } catch (e) {}
            },
            updateOnLossQty(e)
            {
                this.auto.on_loss_increase_qty = e.target.value;
                try {
                    localStorage['on_loss_increase_qty'] = this.auto.on_loss_increase_qty;
                } catch (e) {}
            },
            updateOnWinQty(e)
            {
                this.auto.on_win_increase_qty = e.target.value;
                try {
                    localStorage['on_win_increase_qty'] = this.auto.on_win_increase_qty;
                } catch (e) {}
            },
            updateMaxBetStop(e)
            {
                this.auto.max_bet_stop = e.target.value;
                try {
                    localStorage['max_bet_stop'] = this.auto.max_bet_stop;
                } catch (e) {}
            },
            validation()
            {
                // Validate base bet amount
                let bet = Clib.parseBet(this.$trans, this.auto.base_bet, this.state.currency, this.state.min_bet, this.state.max_bet);
                if (bet instanceof Error) {
                    return bet.message;
                }

                // Validate auto cash amount
                let co = Clib.parseAutoCash(this.$trans, this.auto.auto_cash_at);
                if (co instanceof Error) {
                    return co.message;
                }

                // Validate maxBetAmount
                if (!Clib.isInteger(Number(this.auto.max_bet_stop))) {
                    return this.$trans(`alert.Max bet should be an integer`);
                }

                if (!this.auto.on_loss_increase_qty || this.auto.on_loss_increase_qty < this.state.min_bet) {
                    return this.$trans(`alert.Increase bet by should be greater than`, {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency});
                }

                if (!this.auto.on_win_increase_qty || this.auto.on_win_increase_qty < this.state.min_bet) {
                    return this.$trans(`alert.Increase bet by should be greater than`, {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency});
                }

                if (!Clib.isInteger(Number(this.auto.on_loss_increase_qty))) {
                    return this.$trans(`alert.Increase bet by should be an integer`);
                }

                if (!Clib.isInteger(Number(this.auto.on_win_increase_qty))) {
                    return this.$trans(`alert.Increase bet by should be an integer`);
                }

                let on_loss_increase_qty = Number(this.auto.on_loss_increase_qty);
                let on_win_increase_qty = Number(this.auto.on_win_increase_qty);

                // The bet multiplier should be greater than zero and a number
                if (this.auto.on_loss_increase_qty == 'increase_bet_by') {
                    if (!Clib.isNumber(on_loss_increase_qty)) {
                        return this.$trans(`alert.Increase bet by should be greater than`, {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency});
                    }
                }

                if (this.auto.on_win_increase_qty == 'increase_bet_by') {
                    if (!Clib.isNumber(on_win_increase_qty)) {
                        return this.$trans(`alert.Increase bet by should be greater than`, {min_bet: utils.comma(this.state.min_bet), currency: this.state.currency});
                    }
                }

                return false;
            },
        }
    }
</script>

<style scoped>
.buttons-container button{
    font-size: 12px;
}
.buttons-container select{
    font-size: 12px;
    padding-top: 1px;
}
.control-buttons > .buttons-container {
    width: 100px !important;
    float: right;
}
</style>
